// The EOCube.ro platform around the catalog: the links the PlatformHeader and the footer share with the other
// surfaces (homepage, docs, notebooks), the account page, and the theme choice every *.eocube.ro site shares
// through the `eo-theme` cookie (EOCube Design System, eo.js). The homepage and its legal pages are Romanian at /
// and English under /en/; the docs and the notebooks are one site each.
import './vendor/eo.js';

const HOME = 'https://eocube.ro/';

export const PLATFORM = {
  links(locale) {
    const home = locale === 'ro' ? HOME : `${HOME}en/`;
    return {
      home,
      notebooks: 'https://notebooks.svc.uvt-01.eocube.ro/',
      docs: 'https://docs.eocube.ro/',
      terms: `${home}terms-and-conditions/`,
      privacy: `${home}privacy-policy/`,
      gitlab: 'https://gitlab.dev.info.uvt.ro/rocs'
    };
  },
  // Keycloak's account console ("Profile & tokens") of the realm the catalog signs in with.
  accountUrl(authConfig) {
    const url = authConfig && authConfig.type === 'openIdConnect' && authConfig.openIdConnectUrl;
    if (typeof url !== 'string' || !url.includes('/realms/')) {
      return null;
    }
    return url.replace(/\/\.well-known\/openid-configuration$/, '') + '/account/';
  }
};

// The claims of a JWT (no verification: only to show who is signed in and until when).
export function claimsOf(token) {
  if (typeof token !== 'string') {
    return {};
  }
  const part = token.split('.')[1];
  if (!part) {
    return {};
  }
  try {
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const bytes = Uint8Array.from(json, c => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  }
  catch {
    return {};
  }
}

// The theme: the explicit choice in the shared cookie (EOCube.getTheme() is that, or the system's), written with
// EOCube.setTheme(), which also sets data-theme on <html> for tokens.css. Bootstrap's colour mode (data-bs-theme on
// <html>, bootstrap-vue-next's useColorMode) follows it in StacBrowser.vue.
export const THEME = {
  // The colour mode to start with: the cookie's choice, else the configured one ("auto" follows the system).
  initial(enforced) {
    if (enforced && enforced !== 'auto') {
      return enforced;
    }
    const EO = window.EOCube;
    const stored = EO && /(?:^|;\s*)eo-theme=(light|dark)/.exec(document.cookie || '');
    return stored ? stored[1] : 'auto';
  },
  remember(mode) {
    if (window.EOCube && (mode === 'light' || mode === 'dark')) {
      window.EOCube.setTheme(mode);
    }
  }
};
